import Skeleton from 'react-loading-skeleton';
import { useBreakpoint } from '~/hooks';

export default function TopSellersLoader() {
  const { mobileScreen } = useBreakpoint();
  return (
    <div className="flex gap-2x">
      <div className="w-full mx-auto  bg-gray_light_1 rounded-[16px] p-2x ">
        <div className="mb-3x flex flex-col gap-x md:gap-1.5x ">
          <div className="flex items-center justify-between">
            <Skeleton
              width={200}
              height={24}
              containerClassName="leading-none"
            />

            <div className="flex gap-2x">
              <Skeleton
                width={32}
                height={32}
                containerClassName="leading-none"
                circle
              />
              <Skeleton
                width={32}
                height={32}
                containerClassName="leading-none"
                circle
              />
            </div>
          </div>
          <Skeleton width={100} height={24} containerClassName="leading-none" />
        </div>

        <div className=" relative md:flex mb-4 md:gap-4 h-[72px] md:items-center">
          {Array(mobileScreen ? 1 : 4)
            .fill(0)
            .map((_, index) => (
              <div
                className=" relative mb-4 h-[72px] bg-white rounded-[10px] cursor-pointer flex-1"
                key={index}
              >
                <div className="flex items-center h-full relative">
                  <Skeleton
                    width={72}
                    height={72}
                    containerClassName="leading-none"
                  />

                  <div className="px-1.5x h-full  flex justify-center flex-col gap-1">
                    <Skeleton
                      width={100}
                      height={12}
                      containerClassName="leading-none"
                    />

                    <Skeleton
                      width={60}
                      height={12}
                      containerClassName="leading-none"
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
